import { useState, useEffect } from 'react';

const useDebounce = <T,>(value: T, delay: number, cb?: (value: T) => void): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  useEffect((): (() => void) => {
    const handler = setTimeout((): void => {
      setDebouncedValue(value);
      if (cb) {
        cb(value);
      }
    }, delay);

    return (): void => {
      clearTimeout(handler);
    };
  }, [value, delay, cb]);

  return debouncedValue;
};

export default useDebounce;
